import type { CampaignSearch } from '../search';

/**
 * Build an absolute brand-app deep link for a campaign.
 *
 * - Trims trailing slashes from the base URL so we never double-slash.
 * - Drops undefined / null / empty params so the query stays clean and links
 *   stay short.
 * - Omits the `?` entirely when no params survive.
 *
 * @param brandBaseUrl  Absolute origin of the brand app (e.g. https://app.getdiscovr.ai).
 * @param campaignParam Campaign slug or id used in the `/campaign/:param` route.
 * @param search        Partial deep-link search params to encode.
 */
export function buildCampaignShareUrl(
  brandBaseUrl: string,
  campaignParam: string,
  search: Partial<CampaignSearch>,
): string {
  const base = brandBaseUrl.replace(/\/+$/, '');
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(search)) {
    if (v === undefined || v === null || v === '') continue;
    qs.set(k, String(v));
  }
  const q = qs.toString();
  return `${base}/campaign/${campaignParam}${q ? `?${q}` : ''}`;
}
